"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _client = require("@apollo/client");

var _DecoratorsRoot = require("../../layout/DecoratorsRoot");

var _handleModuleData = require("../gqls/handleModuleData");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

require("../styles/handleModuleData.less");

var styles = {
  "root": "meepshop-meep-ui__menu-handleModuleData__root"
};

var _default = function _default(Component) {
  return (0, _DecoratorsRoot.enhancer)( /*#__PURE__*/_react["default"].memo(function (_ref) {
    var _data$viewer, _data$viewer$store;

    var id = _ref.id,
        menuId = _ref.menuId;

    var _useQuery = (0, _client.useQuery)(_handleModuleData.getMenu, {
      variables: {
        menuId: menuId
      }
    }),
        data = _useQuery.data;

    if (!(data !== null && data !== void 0 && (_data$viewer = data.viewer) !== null && _data$viewer !== void 0 && (_data$viewer$store = _data$viewer.store) !== null && _data$viewer$store !== void 0 && _data$viewer$store.menu)) return null;
    var _data$viewer$store$me = data.viewer.store.menu,
        iconSize = _data$viewer$store$me.iconSize,
        logoAlignment = _data$viewer$store$me.logoAlignment,
        pages = _data$viewer$store$me.pages,
        _data$viewer$store$me2 = _data$viewer$store$me.design,
        expandSubItem = _data$viewer$store$me2.expandSubItem,
        design = (0, _objectWithoutProperties2["default"])(_data$viewer$store$me2, ["expandSubItem"]);
    return /*#__PURE__*/_react["default"].createElement(Component, {
      id: id,
      className: expandSubItem ? '' : styles.root,
      menu: data.viewer.store.menu,
      pages: pages,
      iconSize: iconSize,
      logoAlignment: logoAlignment,
      design: _objectSpread(_objectSpread({}, design), {}, {
        expandSubItem: expandSubItem,
        // TODO: module should not have width
        width: 0
      }),
      isModule: true
    });
  }));
};

exports["default"] = _default;